<script setup lang="ts">
import AppHeader from "./components/AppHeader.vue";
import LogoutDialog from "./components/LogoutDialog.vue";
import SmartFilterDialog from "./components/SmartFilterDialog.vue";
import AccountView from "./views/AccountView.vue";
import AuthView from "./views/AuthView.vue";
import DeviceView from "./views/DeviceView.vue";
import ImageViewer from "./views/ImageViewer.vue";
import LibraryView from "./views/LibraryView.vue";
import OverviewView from "./views/OverviewView.vue";
import ProductInfoView from "./views/ProductInfoView.vue";
import SettingsView from "./views/SettingsView.vue";
</script>

<template>
  <main id="appShell" class="app-shell">
    <AppHeader />
    <AuthView hidden />
    <div id="authenticatedContent" class="authenticated-content">
      <OverviewView />
      <ProductInfoView />
      <LibraryView />
      <ImageViewer />
      <AccountView />
      <DeviceView />
      <SettingsView />
    </div>
    <SmartFilterDialog />
    <LogoutDialog />
  </main>
</template>
